import { render, staticRenderFns } from "./FormInitialize.vue?vue&type=template&id=4690a540&scoped=true"
import script from "./FormInitialize.vue?vue&type=script&lang=js"
export * from "./FormInitialize.vue?vue&type=script&lang=js"
import style0 from "./FormInitialize.vue?vue&type=style&index=0&id=4690a540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4690a540",
  null
  
)

export default component.exports